import { SpecialSymbolType } from './SpecialSymbolType'

export class SymbolsTypeHelper {
    public static isSpecialSymbol(index: number): boolean {
        return index === SpecialSymbolType.MULTIPLIER || index === SpecialSymbolType.SCATTER
    }
}
